import { useState, useEffect } from "react";
import { AgChartsReact } from "ag-charts-react";
import { server } from "../../App";
import { useQuery } from "react-query";
import axios from "axios";
import { YearsOptions, mutualisteOptions } from "../Consultation/bloc3/DropdownOptions/AvOptions";
import { Form, Dropdown,Button,Container } from "semantic-ui-react";
import moment from "moment";
import { useWindowSize } from "react-use";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useGetDoctorsSemanticUI from "../../CustomHooks/useGetDoctorsSemanticUI"

function Years() {
  const Doctors = useGetDoctorsSemanticUI()
  const [Year, setYear] = useState(moment().format("YYYY"));
  const [fk_id_medecin1, setfk_id_medecin1] = useState(0);
  const [mutualiste, setMutualiste] = useState(3);
  const { width } = useWindowSize();


  let myObject = { key: "0000000A", text: "Global", value: 0 }
  let myObject2 = Doctors?.Doctors_list ? Doctors?.Doctors_list : []

  myObject2.push(myObject)

  const gettheEXCELfile = async () => {

//     let url = `${server}excelExport/export/${Year}/${mutualiste}`

//     let MOD_Url = url.replace("AnnualRevenu/", "");
// console.log(MOD_Url);
    
    try {
      const response = await axios.get(`https://aniba.ddns.net/excelExport/export/${Year}/${mutualiste}`, {
        responseType: 'blob',
        headers: {
          jwtoken: sessionStorage.token,
        },
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      // Create a link element, set its href to the blob URL, and trigger a download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `rapport_${Year}_${mutualiste}.xlsx`; // Set the filename
      link.click();
      
      // Clean up by revoking the object URL
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };














  const getDetailedData = () => {
    let url;


    // DEV
    // if (fk_id_medecin1 == 0) {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByOneYearDetails/${Year}`;
    // } else {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByOneYearDetails/${Year}/${fk_id_medecin1}`;
    // }

    // PROD
    if (fk_id_medecin1 == 0) {
      if (mutualiste === 3) {
        url = `${server}StatisticsRoutes/GetRevenuByOneYearDetailsAll/${Year}`;
      } else {
        url = `${server}StatisticsRoutes/GetRevenuByOneYearDetails/${Year}/${mutualiste}`
      }

    } else {
      if (mutualiste === 3) {
        url = `${server}StatisticsRoutes/GetRevenuByOneYearDetailsAll/${Year}/${fk_id_medecin1}`;
      } else {
        url = `${server}StatisticsRoutes/GetRevenuByOneYearDetails/${Year}/${fk_id_medecin1}/${mutualiste}`
      }

    }


    return axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => response.data);
  };
  const { data: detailedData, refetch } = useQuery("DetailedData", () => {
    return getDetailedData();
  });



  const getData = () => {
    let url;


    // DEV
    // if (fk_id_medecin1 == 0) {
    //   url = `${server}AnnualRevenu/StatisticsRoutes`;

    // } else {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/ByDoctor/${fk_id_medecin1}`;

    // }


    // PROD
    if (fk_id_medecin1 == 0) {
      if (mutualiste === 3) {
        url = `${server}StatisticsRoutes`;
      } else {
        url = `${server}StatisticsRoutes/mutu/${mutualiste}`;
      }
    } else {
      if (mutualiste === 3) {
        url = `${server}StatisticsRoutes/ByDoctor/${fk_id_medecin1}`;
      } else {
        url = `${server}StatisticsRoutes/ByDoctorMutu/${fk_id_medecin1}/${mutualiste}`;
      }
    }


    return axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => response.data);
  };
  const { data, refetch: refetch2 } = useQuery("Years", () => {
    return getData();
  });

  useEffect(() => {
    refetch();
    refetch2();
  }, [Year, fk_id_medecin1, mutualiste]);

  let options = {
    title: {
      text: "Revenu annuel du centre",
    },
    subtitle: {
      text: "En Dirham",
    },
    data: data,
    series: [
      {
        type: "column",
        xKey: "année",
        yKeys: ["Total"],
      },
    ],
    legend: {
      position: 'bottom',
    },
  };
  let angle
  if (width < 512) {
    angle = 359
  } else {
    angle = 30
  }

  let options2 = {
    title: {
      text: "Revenu par acte",
    },
    subtitle: {
      text: "Annuel",
    },
    data: detailedData,
    series: [
      {
        type: "pie",
        labelKey: "Acte",
        angleKey: "Total",
        label: {
          minAngle: angle
        }
      },

    ],
    legend: {
      position: 'bottom',
    },
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      fontWeight: 900,
      fontSize: "1.2rem",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  return (
    <>
      <AgChartsReact options={options} />
      {/* <Form>
        <Form.Group widths="equal"> */}
      <div className="FixingAbigProblem">


        <Form.Field
          className="TinySelect"
          value={Year}
          search
          selection
          fluid
          label="Année"
          control={Dropdown}
          options={YearsOptions}
          placeholder="Année"
          onChange={(e, data) => {
            setYear(data.value);
          }}
        />


        <Form.Field
          // className="TinySelect"
          value={fk_id_medecin1}
          search
          selection
          fluid
          label="Médecin"
          control={Dropdown}
          options={myObject2}
          // placeholder="Médecin"
          onChange={(e, data) => {
            setfk_id_medecin1(data.value);
          }}
        />

        <Form.Field
          className="SomeMargin"
          value={mutualiste}
          search
          selection
          fluid
          label="Mutuelle :"
          control={Dropdown}
          options={mutualisteOptions}
          placeholder="Mutualiste"
          onChange={(e, data) => {
            setMutualiste(data.value);
          }}
        />


      </div>
      <br/>
      <Container textAlign='center'>
      <Button 
      color="olive" 
      onClick={gettheEXCELfile}
      disabled={mutualiste !== 0 && mutualiste !== 1}
      >
      Télécharger le fichier Excel 
          </Button>
      </Container>

      {/* </Form.Group>
      </Form> */}
      <AgChartsReact options={options2} />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 260 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Acte</StyledTableCell>
              <StyledTableCell>Nb</StyledTableCell>
              <StyledTableCell>Total</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {detailedData?.map((item, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>{item.Acte}</StyledTableCell>
                <StyledTableCell>{item.Nombre}</StyledTableCell>
                <StyledTableCell>{new Intl.NumberFormat('de-DE').format(item.Total)}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default Years;
